module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "1000"
    },
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 justify-end pb-0"
  }, [_c('v-icon', {
    on: {
      "click": _vm.destroySetup
    }
  }, [_vm._v("mdi-window-close")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 text-uppercase justify-center pt-0"
  }, [_vm._v("Activation Window")]), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticClass: "activation-modal__name-container"
  }, [_c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "audienceName",
      "label": "Audience Name",
      "id": "activationModalAudienceName",
      "readonly": "",
      "hide-details": "true",
      "dense": "",
      "filled": ""
    },
    model: {
      value: (_vm.segment.display_name),
      callback: function($$v) {
        _vm.$set(_vm.segment, "display_name", $$v)
      },
      expression: "segment.display_name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('advertiser-select', {
    attrs: {
      "initialValue": _vm.segment.advertiser,
      "showAdvertiserId": true,
      "disabled": _vm.disableAdvertiser,
      "filled": true
    },
    on: {
      "update": function (val) { return (_vm.segment.advertiser = val); }
    }
  })], 1), _vm._v(" "), (_vm.showViewingStream) ? _c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('streaming-select', {
    attrs: {
      "initialValue": _vm.segment.viewing_stream,
      "viewingOption": _vm.viewingOption,
      "disabled": _vm.disableViewingStream
    },
    on: {
      "input": function (val) { return (_vm.segment.viewing_stream = val); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "activation-modal__bottom-container"
  }, [_c('div', {
    staticClass: "activation-modal__endpoints-area"
  }, _vm._l((_vm.destinations), function(destination) {
    return _c('div', {
      key: destination.id,
      staticClass: "activation-modal__destinations"
    }, [_c('MVPD', {
      attrs: {
        "destination": destination,
        "selected": _vm.segment.destinations.includes(destination.id),
        "canUpdate": false,
        "UE": 0
      },
      on: {
        "selectedDestination": function($event) {
          return _vm.selectDestination(destination)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), (!_vm.foresiteDestinationSelected) ? _c('v-container', {
    staticClass: "activation-modal__campaign-area"
  }, [(_vm.isDigitalDestination || _vm.isDDLDestination) ? _c('v-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('flight-dates', {
    attrs: {
      "value": {
        flightStartDate: _vm.segment.am_data.flightStartDate,
        flightEndDate: _vm.segment.am_data.flightEndDate,
      }
    },
    on: {
      "input": function (val) { return Object.assign(_vm.segment.am_data, val); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFreeWheelOrGAMDestination && _vm.hasNotBeenPreviouslyModeled) ? _c('v-divider', {
    staticClass: "mt-5 mb-5"
  }) : _vm._e(), _vm._v(" "), (_vm.isFreeWheelOrGAMDestination && _vm.hasNotBeenPreviouslyModeled) ? _c('v-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('segment-split', {
    on: {
      "valid": function (val) { return (_vm.isSplitValid = val); },
      "segmentSplit": function (val) { return (_vm.segmentSplit = val); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFrequency) ? _c('v-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('frequency-d-d-l', {
    attrs: {
      "initialValue": _vm.frequency,
      "optionSet": _vm.frequencyOptionSet,
      "disabled": _vm.disableFrequency
    },
    on: {
      "input": function (val) { return (_vm.segment.xandr_data.frequency = val); }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.foresiteDestinationSelected) ? _c('div', {
    staticClass: "activation-modal__broadcast-quarter-area"
  }, [_c('broadcast-quarter-select', {
    on: {
      "input": function (val) { return (_vm.broadcastQuarter = val); }
    }
  }), _vm._v(" "), _c('demo-qualifier', {
    on: {
      "demoQualifier": function (val) { return (_vm.demoQualifier = val); }
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-text', [(_vm.showAdvertiserRequiredMessage) ? _c('v-row', {
    staticClass: "justify-space-around subtitle-1 font-weight-bold"
  }, [_vm._v("\n        Advertiser is required in order to send downstream\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pb-6",
    staticStyle: {
      "min-height": "60px"
    }
  }, [_c('v-row', {
    staticClass: "justify-space-around"
  }, [(!_vm.activatingAudience && !_vm.disableSendDownstream) ? _c('action-button', {
    attrs: {
      "dark": "",
      "disabled": _vm.disableSendDownstream,
      "label": "Send Downstream",
      "color": "primary",
      "id": "sendDownstreamModalBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitDownstream.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-893e4b4e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/activation/ActivationModal.vue
// module id = 2150
// module chunks = 0